// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var BillingProvider = function (x) {
    return x;
};
var tsBridgeBillingProvider = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("BillingProvider")("__brandBillingProvider"));
    }
};
var writeBillingProvider = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showBillingProvider = Data_Show.showString;
var readBillingProvider = Simple_JSON.readString;
var ordBillingProvider = Data_Ord.ordString;
var newtypeBillingProvider = {
    Coercible0: function () {
        return undefined;
    }
};
var makeBillingProvider = BillingProvider;
var eqBillingProvider = Data_Eq.eqString;
export {
    BillingProvider,
    makeBillingProvider,
    unwrap,
    newtypeBillingProvider,
    eqBillingProvider,
    ordBillingProvider,
    showBillingProvider,
    readBillingProvider,
    writeBillingProvider,
    tsBridgeBillingProvider
};
//# sourceMappingURL=index.js.map
